import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconThumbsDown(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.133.667h1.757a2.206 2.206 0 0 1 2.226 1.911l.006.089v4.667l-.006.089a2.205 2.205 0 0 1-2.214 1.911h-1.347l-2.491 5.604a.667.667 0 0 1-.609.396 2.667 2.667 0 0 1-2.667-2.667v-2H2.689a1.998 1.998 0 0 1-2-2.301l.92-5.999a1.999 1.999 0 0 1 1.992-1.7h7.531zM3.594 2a.667.667 0 0 0-.667.568l-.92 5.999a.668.668 0 0 0 .674.766h3.773c.368 0 .667.298.667.667v2.667c0 .595.39 1.099.928 1.271l2.405-5.412V2.001zm8.194 6h1.125a.873.873 0 0 0 .875-.718V2.718A.877.877 0 0 0 12.901 2h-1.113z"
  }));
}
IconThumbsDown.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconThumbsDown.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconThumbsDown as default };
